/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as ScoutDownloadRouteImport } from './routes/scout-download'
import { Route as ScrapingRouteImport } from './routes/scraping'
import { Route as CheckoutReturnRouteImport } from './routes/checkout/return'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as LoginMicrosoftRouteImport } from './routes/login/microsoft'
import { Route as LoginScoutRouteImport } from './routes/login/scout'
import { Route as WorkspaceWorkspaceIdRouteRouteImport } from './routes/workspace/$workspaceId/route'
import { Route as WorkspaceCreateRouteRouteImport } from './routes/workspace/create/route'
import { Route as WorkspaceInternalRouteImport } from './routes/workspace/internal'
import { Route as WorkspaceWorkspaceIdIndexRouteImport } from './routes/workspace/$workspaceId/index'
import { Route as WorkspaceWorkspaceIdCheckoutRouteImport } from './routes/workspace/$workspaceId/checkout'
import { Route as WorkspaceWorkspaceIdCreateNewRouteImport } from './routes/workspace/$workspaceId/create-new'
import { Route as WorkspaceWorkspaceIdInsightRouteRouteImport } from './routes/workspace/$workspaceId/insight/route'
import { Route as WorkspaceWorkspaceIdInvalidWorkspaceRouteImport } from './routes/workspace/$workspaceId/invalid-workspace'
import { Route as WorkspaceWorkspaceIdListeningRouteImport } from './routes/workspace/$workspaceId/listening'
import { Route as WorkspaceWorkspaceIdPlanRequiredRouteImport } from './routes/workspace/$workspaceId/plan-required'
import { Route as WorkspaceWorkspaceIdSettingsRouteRouteImport } from './routes/workspace/$workspaceId/settings/route'
import { Route as WorkspaceCreateIndexRouteImport } from './routes/workspace/create/index'
import { Route as WorkspaceCreateNameRouteImport } from './routes/workspace/create/name'
import { Route as WorkspaceWorkspaceIdAskSynclyIndexRouteImport } from './routes/workspace/$workspaceId/ask-syncly/index'
import { Route as WorkspaceWorkspaceIdBoardsIndexRouteImport } from './routes/workspace/$workspaceId/boards/index'
import { Route as WorkspaceWorkspaceIdBoardsBoardIdRouteImport } from './routes/workspace/$workspaceId/boards/$boardId'
import { Route as WorkspaceWorkspaceIdCampaignsIndexRouteImport } from './routes/workspace/$workspaceId/campaigns/index'
import { Route as WorkspaceWorkspaceIdCampaignsCreateRouteImport } from './routes/workspace/$workspaceId/campaigns/create'
import { Route as WorkspaceWorkspaceIdDiscoveryIndexRouteImport } from './routes/workspace/$workspaceId/discovery/index'
import { Route as WorkspaceWorkspaceIdInsightIndexRouteImport } from './routes/workspace/$workspaceId/insight/index'
import { Route as WorkspaceWorkspaceIdInsightFilteredPostsRouteImport } from './routes/workspace/$workspaceId/insight/filtered-posts'
import { Route as WorkspaceWorkspaceIdInsightFilteredProfilesRouteImport } from './routes/workspace/$workspaceId/insight/filtered-profiles'
import { Route as WorkspaceWorkspaceIdInsightOverviewRouteImport } from './routes/workspace/$workspaceId/insight/overview'
import { Route as WorkspaceWorkspaceIdInsightPeopleRouteImport } from './routes/workspace/$workspaceId/insight/people'
import { Route as WorkspaceWorkspaceIdInsightPerformanceRouteImport } from './routes/workspace/$workspaceId/insight/performance'
import { Route as WorkspaceWorkspaceIdInsightPostsRouteImport } from './routes/workspace/$workspaceId/insight/posts'
import { Route as WorkspaceWorkspaceIdInsightReferencedPostsRouteImport } from './routes/workspace/$workspaceId/insight/referenced-posts'
import { Route as WorkspaceWorkspaceIdPostPostIdRouteImport } from './routes/workspace/$workspaceId/post/$postId'
import { Route as WorkspaceWorkspaceIdSavedProfilesIndexRouteImport } from './routes/workspace/$workspaceId/saved-profiles/index'
import { Route as WorkspaceWorkspaceIdSettingsIndexRouteImport } from './routes/workspace/$workspaceId/settings/index'
import { Route as WorkspaceWorkspaceIdSettingsBillingRouteImport } from './routes/workspace/$workspaceId/settings/billing'
import { Route as WorkspaceWorkspaceIdSettingsGeneralRouteImport } from './routes/workspace/$workspaceId/settings/general'
import { Route as WorkspaceWorkspaceIdSettingsMemberRouteImport } from './routes/workspace/$workspaceId/settings/member'
import { Route as WorkspaceWorkspaceIdSettingsPlanRouteImport } from './routes/workspace/$workspaceId/settings/plan'
import { Route as WorkspaceWorkspaceIdSettingsUsageRouteImport } from './routes/workspace/$workspaceId/settings/usage'
import { Route as WorkspaceWorkspaceIdCampaignsCampaignIdIndexRouteImport } from './routes/workspace/$workspaceId/campaigns/$campaignId/index'
import { Route as WorkspaceWorkspaceIdSavedProfilesListIdIndexRouteImport } from './routes/workspace/$workspaceId/saved-profiles/$listId/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const ScoutDownloadRoute = ScoutDownloadRouteImport.update({
  id: '/scout-download',
  path: '/scout-download',
  getParentRoute: () => rootRouteImport,
} as any)
const ScrapingRoute = ScrapingRouteImport.update({
  id: '/scraping',
  path: '/scraping',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
  id: '/checkout/return',
  path: '/checkout/return',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginMicrosoftRoute = LoginMicrosoftRouteImport.update({
  id: '/login/microsoft',
  path: '/login/microsoft',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginScoutRoute = LoginScoutRouteImport.update({
  id: '/login/scout',
  path: '/login/scout',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceWorkspaceIdRouteRoute =
  WorkspaceWorkspaceIdRouteRouteImport.update({
    id: '/workspace/$workspaceId',
    path: '/workspace/$workspaceId',
    getParentRoute: () => rootRouteImport,
  } as any)
const WorkspaceCreateRouteRoute = WorkspaceCreateRouteRouteImport.update({
  id: '/workspace/create',
  path: '/workspace/create',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceInternalRoute = WorkspaceInternalRouteImport.update({
  id: '/workspace/internal',
  path: '/workspace/internal',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceWorkspaceIdIndexRoute =
  WorkspaceWorkspaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceWorkspaceIdCheckoutRoute =
  WorkspaceWorkspaceIdCheckoutRouteImport.update({
    id: '/checkout',
    path: '/checkout',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceWorkspaceIdCreateNewRoute =
  WorkspaceWorkspaceIdCreateNewRouteImport.update({
    id: '/create-new',
    path: '/create-new',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceWorkspaceIdInsightRouteRoute =
  WorkspaceWorkspaceIdInsightRouteRouteImport.update({
    id: '/insight',
    path: '/insight',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceWorkspaceIdInvalidWorkspaceRoute =
  WorkspaceWorkspaceIdInvalidWorkspaceRouteImport.update({
    id: '/invalid-workspace',
    path: '/invalid-workspace',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceWorkspaceIdListeningRoute =
  WorkspaceWorkspaceIdListeningRouteImport.update({
    id: '/listening',
    path: '/listening',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceWorkspaceIdPlanRequiredRoute =
  WorkspaceWorkspaceIdPlanRequiredRouteImport.update({
    id: '/plan-required',
    path: '/plan-required',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceWorkspaceIdSettingsRouteRoute =
  WorkspaceWorkspaceIdSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceCreateIndexRoute = WorkspaceCreateIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkspaceCreateRouteRoute,
} as any)
const WorkspaceCreateNameRoute = WorkspaceCreateNameRouteImport.update({
  id: '/name',
  path: '/name',
  getParentRoute: () => WorkspaceCreateRouteRoute,
} as any)
const WorkspaceWorkspaceIdAskSynclyIndexRoute =
  WorkspaceWorkspaceIdAskSynclyIndexRouteImport.update({
    id: '/ask-syncly/',
    path: '/ask-syncly/',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceWorkspaceIdBoardsIndexRoute =
  WorkspaceWorkspaceIdBoardsIndexRouteImport.update({
    id: '/boards/',
    path: '/boards/',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceWorkspaceIdBoardsBoardIdRoute =
  WorkspaceWorkspaceIdBoardsBoardIdRouteImport.update({
    id: '/boards/$boardId',
    path: '/boards/$boardId',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceWorkspaceIdCampaignsIndexRoute =
  WorkspaceWorkspaceIdCampaignsIndexRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns/',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceWorkspaceIdCampaignsCreateRoute =
  WorkspaceWorkspaceIdCampaignsCreateRouteImport.update({
    id: '/campaigns/create',
    path: '/campaigns/create',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceWorkspaceIdDiscoveryIndexRoute =
  WorkspaceWorkspaceIdDiscoveryIndexRouteImport.update({
    id: '/discovery/',
    path: '/discovery/',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceWorkspaceIdInsightIndexRoute =
  WorkspaceWorkspaceIdInsightIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceWorkspaceIdInsightRouteRoute,
  } as any)
const WorkspaceWorkspaceIdInsightFilteredPostsRoute =
  WorkspaceWorkspaceIdInsightFilteredPostsRouteImport.update({
    id: '/filtered-posts',
    path: '/filtered-posts',
    getParentRoute: () => WorkspaceWorkspaceIdInsightRouteRoute,
  } as any)
const WorkspaceWorkspaceIdInsightFilteredProfilesRoute =
  WorkspaceWorkspaceIdInsightFilteredProfilesRouteImport.update({
    id: '/filtered-profiles',
    path: '/filtered-profiles',
    getParentRoute: () => WorkspaceWorkspaceIdInsightRouteRoute,
  } as any)
const WorkspaceWorkspaceIdInsightOverviewRoute =
  WorkspaceWorkspaceIdInsightOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => WorkspaceWorkspaceIdInsightRouteRoute,
  } as any)
const WorkspaceWorkspaceIdInsightPeopleRoute =
  WorkspaceWorkspaceIdInsightPeopleRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => WorkspaceWorkspaceIdInsightRouteRoute,
  } as any)
const WorkspaceWorkspaceIdInsightPerformanceRoute =
  WorkspaceWorkspaceIdInsightPerformanceRouteImport.update({
    id: '/performance',
    path: '/performance',
    getParentRoute: () => WorkspaceWorkspaceIdInsightRouteRoute,
  } as any)
const WorkspaceWorkspaceIdInsightPostsRoute =
  WorkspaceWorkspaceIdInsightPostsRouteImport.update({
    id: '/posts',
    path: '/posts',
    getParentRoute: () => WorkspaceWorkspaceIdInsightRouteRoute,
  } as any)
const WorkspaceWorkspaceIdInsightReferencedPostsRoute =
  WorkspaceWorkspaceIdInsightReferencedPostsRouteImport.update({
    id: '/referenced-posts',
    path: '/referenced-posts',
    getParentRoute: () => WorkspaceWorkspaceIdInsightRouteRoute,
  } as any)
const WorkspaceWorkspaceIdPostPostIdRoute =
  WorkspaceWorkspaceIdPostPostIdRouteImport.update({
    id: '/post/$postId',
    path: '/post/$postId',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceWorkspaceIdSavedProfilesIndexRoute =
  WorkspaceWorkspaceIdSavedProfilesIndexRouteImport.update({
    id: '/saved-profiles/',
    path: '/saved-profiles/',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceWorkspaceIdSettingsIndexRoute =
  WorkspaceWorkspaceIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspaceWorkspaceIdSettingsRouteRoute,
  } as any)
const WorkspaceWorkspaceIdSettingsBillingRoute =
  WorkspaceWorkspaceIdSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => WorkspaceWorkspaceIdSettingsRouteRoute,
  } as any)
const WorkspaceWorkspaceIdSettingsGeneralRoute =
  WorkspaceWorkspaceIdSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => WorkspaceWorkspaceIdSettingsRouteRoute,
  } as any)
const WorkspaceWorkspaceIdSettingsMemberRoute =
  WorkspaceWorkspaceIdSettingsMemberRouteImport.update({
    id: '/member',
    path: '/member',
    getParentRoute: () => WorkspaceWorkspaceIdSettingsRouteRoute,
  } as any)
const WorkspaceWorkspaceIdSettingsPlanRoute =
  WorkspaceWorkspaceIdSettingsPlanRouteImport.update({
    id: '/plan',
    path: '/plan',
    getParentRoute: () => WorkspaceWorkspaceIdSettingsRouteRoute,
  } as any)
const WorkspaceWorkspaceIdSettingsUsageRoute =
  WorkspaceWorkspaceIdSettingsUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => WorkspaceWorkspaceIdSettingsRouteRoute,
  } as any)
const WorkspaceWorkspaceIdCampaignsCampaignIdIndexRoute =
  WorkspaceWorkspaceIdCampaignsCampaignIdIndexRouteImport.update({
    id: '/campaigns/$campaignId/',
    path: '/campaigns/$campaignId/',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)
const WorkspaceWorkspaceIdSavedProfilesListIdIndexRoute =
  WorkspaceWorkspaceIdSavedProfilesListIdIndexRouteImport.update({
    id: '/saved-profiles/$listId/',
    path: '/saved-profiles/$listId/',
    getParentRoute: () => WorkspaceWorkspaceIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/invite': typeof InviteRoute
  '/scout-download': typeof ScoutDownloadRoute
  '/scraping': typeof ScrapingRoute
  '/workspace/$workspaceId': typeof WorkspaceWorkspaceIdRouteRouteWithChildren
  '/workspace/create': typeof WorkspaceCreateRouteRouteWithChildren
  '/checkout/return': typeof CheckoutReturnRoute
  '/login/microsoft': typeof LoginMicrosoftRoute
  '/login/scout': typeof LoginScoutRoute
  '/workspace/internal': typeof WorkspaceInternalRoute
  '/login/': typeof LoginIndexRoute
  '/workspace/$workspaceId/insight': typeof WorkspaceWorkspaceIdInsightRouteRouteWithChildren
  '/workspace/$workspaceId/settings': typeof WorkspaceWorkspaceIdSettingsRouteRouteWithChildren
  '/workspace/$workspaceId/checkout': typeof WorkspaceWorkspaceIdCheckoutRoute
  '/workspace/$workspaceId/create-new': typeof WorkspaceWorkspaceIdCreateNewRoute
  '/workspace/$workspaceId/invalid-workspace': typeof WorkspaceWorkspaceIdInvalidWorkspaceRoute
  '/workspace/$workspaceId/listening': typeof WorkspaceWorkspaceIdListeningRoute
  '/workspace/$workspaceId/plan-required': typeof WorkspaceWorkspaceIdPlanRequiredRoute
  '/workspace/create/name': typeof WorkspaceCreateNameRoute
  '/workspace/$workspaceId/': typeof WorkspaceWorkspaceIdIndexRoute
  '/workspace/create/': typeof WorkspaceCreateIndexRoute
  '/workspace/$workspaceId/boards/$boardId': typeof WorkspaceWorkspaceIdBoardsBoardIdRoute
  '/workspace/$workspaceId/campaigns/create': typeof WorkspaceWorkspaceIdCampaignsCreateRoute
  '/workspace/$workspaceId/insight/filtered-posts': typeof WorkspaceWorkspaceIdInsightFilteredPostsRoute
  '/workspace/$workspaceId/insight/filtered-profiles': typeof WorkspaceWorkspaceIdInsightFilteredProfilesRoute
  '/workspace/$workspaceId/insight/overview': typeof WorkspaceWorkspaceIdInsightOverviewRoute
  '/workspace/$workspaceId/insight/people': typeof WorkspaceWorkspaceIdInsightPeopleRoute
  '/workspace/$workspaceId/insight/performance': typeof WorkspaceWorkspaceIdInsightPerformanceRoute
  '/workspace/$workspaceId/insight/posts': typeof WorkspaceWorkspaceIdInsightPostsRoute
  '/workspace/$workspaceId/insight/referenced-posts': typeof WorkspaceWorkspaceIdInsightReferencedPostsRoute
  '/workspace/$workspaceId/post/$postId': typeof WorkspaceWorkspaceIdPostPostIdRoute
  '/workspace/$workspaceId/settings/billing': typeof WorkspaceWorkspaceIdSettingsBillingRoute
  '/workspace/$workspaceId/settings/general': typeof WorkspaceWorkspaceIdSettingsGeneralRoute
  '/workspace/$workspaceId/settings/member': typeof WorkspaceWorkspaceIdSettingsMemberRoute
  '/workspace/$workspaceId/settings/plan': typeof WorkspaceWorkspaceIdSettingsPlanRoute
  '/workspace/$workspaceId/settings/usage': typeof WorkspaceWorkspaceIdSettingsUsageRoute
  '/workspace/$workspaceId/ask-syncly/': typeof WorkspaceWorkspaceIdAskSynclyIndexRoute
  '/workspace/$workspaceId/boards/': typeof WorkspaceWorkspaceIdBoardsIndexRoute
  '/workspace/$workspaceId/campaigns/': typeof WorkspaceWorkspaceIdCampaignsIndexRoute
  '/workspace/$workspaceId/discovery/': typeof WorkspaceWorkspaceIdDiscoveryIndexRoute
  '/workspace/$workspaceId/insight/': typeof WorkspaceWorkspaceIdInsightIndexRoute
  '/workspace/$workspaceId/saved-profiles/': typeof WorkspaceWorkspaceIdSavedProfilesIndexRoute
  '/workspace/$workspaceId/settings/': typeof WorkspaceWorkspaceIdSettingsIndexRoute
  '/workspace/$workspaceId/campaigns/$campaignId/': typeof WorkspaceWorkspaceIdCampaignsCampaignIdIndexRoute
  '/workspace/$workspaceId/saved-profiles/$listId/': typeof WorkspaceWorkspaceIdSavedProfilesListIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/invite': typeof InviteRoute
  '/scout-download': typeof ScoutDownloadRoute
  '/scraping': typeof ScrapingRoute
  '/checkout/return': typeof CheckoutReturnRoute
  '/login/microsoft': typeof LoginMicrosoftRoute
  '/login/scout': typeof LoginScoutRoute
  '/workspace/internal': typeof WorkspaceInternalRoute
  '/login': typeof LoginIndexRoute
  '/workspace/$workspaceId/checkout': typeof WorkspaceWorkspaceIdCheckoutRoute
  '/workspace/$workspaceId/create-new': typeof WorkspaceWorkspaceIdCreateNewRoute
  '/workspace/$workspaceId/invalid-workspace': typeof WorkspaceWorkspaceIdInvalidWorkspaceRoute
  '/workspace/$workspaceId/listening': typeof WorkspaceWorkspaceIdListeningRoute
  '/workspace/$workspaceId/plan-required': typeof WorkspaceWorkspaceIdPlanRequiredRoute
  '/workspace/create/name': typeof WorkspaceCreateNameRoute
  '/workspace/$workspaceId': typeof WorkspaceWorkspaceIdIndexRoute
  '/workspace/create': typeof WorkspaceCreateIndexRoute
  '/workspace/$workspaceId/boards/$boardId': typeof WorkspaceWorkspaceIdBoardsBoardIdRoute
  '/workspace/$workspaceId/campaigns/create': typeof WorkspaceWorkspaceIdCampaignsCreateRoute
  '/workspace/$workspaceId/insight/filtered-posts': typeof WorkspaceWorkspaceIdInsightFilteredPostsRoute
  '/workspace/$workspaceId/insight/filtered-profiles': typeof WorkspaceWorkspaceIdInsightFilteredProfilesRoute
  '/workspace/$workspaceId/insight/overview': typeof WorkspaceWorkspaceIdInsightOverviewRoute
  '/workspace/$workspaceId/insight/people': typeof WorkspaceWorkspaceIdInsightPeopleRoute
  '/workspace/$workspaceId/insight/performance': typeof WorkspaceWorkspaceIdInsightPerformanceRoute
  '/workspace/$workspaceId/insight/posts': typeof WorkspaceWorkspaceIdInsightPostsRoute
  '/workspace/$workspaceId/insight/referenced-posts': typeof WorkspaceWorkspaceIdInsightReferencedPostsRoute
  '/workspace/$workspaceId/post/$postId': typeof WorkspaceWorkspaceIdPostPostIdRoute
  '/workspace/$workspaceId/settings/billing': typeof WorkspaceWorkspaceIdSettingsBillingRoute
  '/workspace/$workspaceId/settings/general': typeof WorkspaceWorkspaceIdSettingsGeneralRoute
  '/workspace/$workspaceId/settings/member': typeof WorkspaceWorkspaceIdSettingsMemberRoute
  '/workspace/$workspaceId/settings/plan': typeof WorkspaceWorkspaceIdSettingsPlanRoute
  '/workspace/$workspaceId/settings/usage': typeof WorkspaceWorkspaceIdSettingsUsageRoute
  '/workspace/$workspaceId/ask-syncly': typeof WorkspaceWorkspaceIdAskSynclyIndexRoute
  '/workspace/$workspaceId/boards': typeof WorkspaceWorkspaceIdBoardsIndexRoute
  '/workspace/$workspaceId/campaigns': typeof WorkspaceWorkspaceIdCampaignsIndexRoute
  '/workspace/$workspaceId/discovery': typeof WorkspaceWorkspaceIdDiscoveryIndexRoute
  '/workspace/$workspaceId/insight': typeof WorkspaceWorkspaceIdInsightIndexRoute
  '/workspace/$workspaceId/saved-profiles': typeof WorkspaceWorkspaceIdSavedProfilesIndexRoute
  '/workspace/$workspaceId/settings': typeof WorkspaceWorkspaceIdSettingsIndexRoute
  '/workspace/$workspaceId/campaigns/$campaignId': typeof WorkspaceWorkspaceIdCampaignsCampaignIdIndexRoute
  '/workspace/$workspaceId/saved-profiles/$listId': typeof WorkspaceWorkspaceIdSavedProfilesListIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/invite': typeof InviteRoute
  '/scout-download': typeof ScoutDownloadRoute
  '/scraping': typeof ScrapingRoute
  '/workspace/$workspaceId': typeof WorkspaceWorkspaceIdRouteRouteWithChildren
  '/workspace/create': typeof WorkspaceCreateRouteRouteWithChildren
  '/checkout/return': typeof CheckoutReturnRoute
  '/login/microsoft': typeof LoginMicrosoftRoute
  '/login/scout': typeof LoginScoutRoute
  '/workspace/internal': typeof WorkspaceInternalRoute
  '/login/': typeof LoginIndexRoute
  '/workspace/$workspaceId/insight': typeof WorkspaceWorkspaceIdInsightRouteRouteWithChildren
  '/workspace/$workspaceId/settings': typeof WorkspaceWorkspaceIdSettingsRouteRouteWithChildren
  '/workspace/$workspaceId/checkout': typeof WorkspaceWorkspaceIdCheckoutRoute
  '/workspace/$workspaceId/create-new': typeof WorkspaceWorkspaceIdCreateNewRoute
  '/workspace/$workspaceId/invalid-workspace': typeof WorkspaceWorkspaceIdInvalidWorkspaceRoute
  '/workspace/$workspaceId/listening': typeof WorkspaceWorkspaceIdListeningRoute
  '/workspace/$workspaceId/plan-required': typeof WorkspaceWorkspaceIdPlanRequiredRoute
  '/workspace/create/name': typeof WorkspaceCreateNameRoute
  '/workspace/$workspaceId/': typeof WorkspaceWorkspaceIdIndexRoute
  '/workspace/create/': typeof WorkspaceCreateIndexRoute
  '/workspace/$workspaceId/boards/$boardId': typeof WorkspaceWorkspaceIdBoardsBoardIdRoute
  '/workspace/$workspaceId/campaigns/create': typeof WorkspaceWorkspaceIdCampaignsCreateRoute
  '/workspace/$workspaceId/insight/filtered-posts': typeof WorkspaceWorkspaceIdInsightFilteredPostsRoute
  '/workspace/$workspaceId/insight/filtered-profiles': typeof WorkspaceWorkspaceIdInsightFilteredProfilesRoute
  '/workspace/$workspaceId/insight/overview': typeof WorkspaceWorkspaceIdInsightOverviewRoute
  '/workspace/$workspaceId/insight/people': typeof WorkspaceWorkspaceIdInsightPeopleRoute
  '/workspace/$workspaceId/insight/performance': typeof WorkspaceWorkspaceIdInsightPerformanceRoute
  '/workspace/$workspaceId/insight/posts': typeof WorkspaceWorkspaceIdInsightPostsRoute
  '/workspace/$workspaceId/insight/referenced-posts': typeof WorkspaceWorkspaceIdInsightReferencedPostsRoute
  '/workspace/$workspaceId/post/$postId': typeof WorkspaceWorkspaceIdPostPostIdRoute
  '/workspace/$workspaceId/settings/billing': typeof WorkspaceWorkspaceIdSettingsBillingRoute
  '/workspace/$workspaceId/settings/general': typeof WorkspaceWorkspaceIdSettingsGeneralRoute
  '/workspace/$workspaceId/settings/member': typeof WorkspaceWorkspaceIdSettingsMemberRoute
  '/workspace/$workspaceId/settings/plan': typeof WorkspaceWorkspaceIdSettingsPlanRoute
  '/workspace/$workspaceId/settings/usage': typeof WorkspaceWorkspaceIdSettingsUsageRoute
  '/workspace/$workspaceId/ask-syncly/': typeof WorkspaceWorkspaceIdAskSynclyIndexRoute
  '/workspace/$workspaceId/boards/': typeof WorkspaceWorkspaceIdBoardsIndexRoute
  '/workspace/$workspaceId/campaigns/': typeof WorkspaceWorkspaceIdCampaignsIndexRoute
  '/workspace/$workspaceId/discovery/': typeof WorkspaceWorkspaceIdDiscoveryIndexRoute
  '/workspace/$workspaceId/insight/': typeof WorkspaceWorkspaceIdInsightIndexRoute
  '/workspace/$workspaceId/saved-profiles/': typeof WorkspaceWorkspaceIdSavedProfilesIndexRoute
  '/workspace/$workspaceId/settings/': typeof WorkspaceWorkspaceIdSettingsIndexRoute
  '/workspace/$workspaceId/campaigns/$campaignId/': typeof WorkspaceWorkspaceIdCampaignsCampaignIdIndexRoute
  '/workspace/$workspaceId/saved-profiles/$listId/': typeof WorkspaceWorkspaceIdSavedProfilesListIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/invite'
    | '/scout-download'
    | '/scraping'
    | '/workspace/$workspaceId'
    | '/workspace/create'
    | '/checkout/return'
    | '/login/microsoft'
    | '/login/scout'
    | '/workspace/internal'
    | '/login/'
    | '/workspace/$workspaceId/insight'
    | '/workspace/$workspaceId/settings'
    | '/workspace/$workspaceId/checkout'
    | '/workspace/$workspaceId/create-new'
    | '/workspace/$workspaceId/invalid-workspace'
    | '/workspace/$workspaceId/listening'
    | '/workspace/$workspaceId/plan-required'
    | '/workspace/create/name'
    | '/workspace/$workspaceId/'
    | '/workspace/create/'
    | '/workspace/$workspaceId/boards/$boardId'
    | '/workspace/$workspaceId/campaigns/create'
    | '/workspace/$workspaceId/insight/filtered-posts'
    | '/workspace/$workspaceId/insight/filtered-profiles'
    | '/workspace/$workspaceId/insight/overview'
    | '/workspace/$workspaceId/insight/people'
    | '/workspace/$workspaceId/insight/performance'
    | '/workspace/$workspaceId/insight/posts'
    | '/workspace/$workspaceId/insight/referenced-posts'
    | '/workspace/$workspaceId/post/$postId'
    | '/workspace/$workspaceId/settings/billing'
    | '/workspace/$workspaceId/settings/general'
    | '/workspace/$workspaceId/settings/member'
    | '/workspace/$workspaceId/settings/plan'
    | '/workspace/$workspaceId/settings/usage'
    | '/workspace/$workspaceId/ask-syncly/'
    | '/workspace/$workspaceId/boards/'
    | '/workspace/$workspaceId/campaigns/'
    | '/workspace/$workspaceId/discovery/'
    | '/workspace/$workspaceId/insight/'
    | '/workspace/$workspaceId/saved-profiles/'
    | '/workspace/$workspaceId/settings/'
    | '/workspace/$workspaceId/campaigns/$campaignId/'
    | '/workspace/$workspaceId/saved-profiles/$listId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/invite'
    | '/scout-download'
    | '/scraping'
    | '/checkout/return'
    | '/login/microsoft'
    | '/login/scout'
    | '/workspace/internal'
    | '/login'
    | '/workspace/$workspaceId/checkout'
    | '/workspace/$workspaceId/create-new'
    | '/workspace/$workspaceId/invalid-workspace'
    | '/workspace/$workspaceId/listening'
    | '/workspace/$workspaceId/plan-required'
    | '/workspace/create/name'
    | '/workspace/$workspaceId'
    | '/workspace/create'
    | '/workspace/$workspaceId/boards/$boardId'
    | '/workspace/$workspaceId/campaigns/create'
    | '/workspace/$workspaceId/insight/filtered-posts'
    | '/workspace/$workspaceId/insight/filtered-profiles'
    | '/workspace/$workspaceId/insight/overview'
    | '/workspace/$workspaceId/insight/people'
    | '/workspace/$workspaceId/insight/performance'
    | '/workspace/$workspaceId/insight/posts'
    | '/workspace/$workspaceId/insight/referenced-posts'
    | '/workspace/$workspaceId/post/$postId'
    | '/workspace/$workspaceId/settings/billing'
    | '/workspace/$workspaceId/settings/general'
    | '/workspace/$workspaceId/settings/member'
    | '/workspace/$workspaceId/settings/plan'
    | '/workspace/$workspaceId/settings/usage'
    | '/workspace/$workspaceId/ask-syncly'
    | '/workspace/$workspaceId/boards'
    | '/workspace/$workspaceId/campaigns'
    | '/workspace/$workspaceId/discovery'
    | '/workspace/$workspaceId/insight'
    | '/workspace/$workspaceId/saved-profiles'
    | '/workspace/$workspaceId/settings'
    | '/workspace/$workspaceId/campaigns/$campaignId'
    | '/workspace/$workspaceId/saved-profiles/$listId'
  id:
    | '__root__'
    | '/'
    | '/invite'
    | '/scout-download'
    | '/scraping'
    | '/workspace/$workspaceId'
    | '/workspace/create'
    | '/checkout/return'
    | '/login/microsoft'
    | '/login/scout'
    | '/workspace/internal'
    | '/login/'
    | '/workspace/$workspaceId/insight'
    | '/workspace/$workspaceId/settings'
    | '/workspace/$workspaceId/checkout'
    | '/workspace/$workspaceId/create-new'
    | '/workspace/$workspaceId/invalid-workspace'
    | '/workspace/$workspaceId/listening'
    | '/workspace/$workspaceId/plan-required'
    | '/workspace/create/name'
    | '/workspace/$workspaceId/'
    | '/workspace/create/'
    | '/workspace/$workspaceId/boards/$boardId'
    | '/workspace/$workspaceId/campaigns/create'
    | '/workspace/$workspaceId/insight/filtered-posts'
    | '/workspace/$workspaceId/insight/filtered-profiles'
    | '/workspace/$workspaceId/insight/overview'
    | '/workspace/$workspaceId/insight/people'
    | '/workspace/$workspaceId/insight/performance'
    | '/workspace/$workspaceId/insight/posts'
    | '/workspace/$workspaceId/insight/referenced-posts'
    | '/workspace/$workspaceId/post/$postId'
    | '/workspace/$workspaceId/settings/billing'
    | '/workspace/$workspaceId/settings/general'
    | '/workspace/$workspaceId/settings/member'
    | '/workspace/$workspaceId/settings/plan'
    | '/workspace/$workspaceId/settings/usage'
    | '/workspace/$workspaceId/ask-syncly/'
    | '/workspace/$workspaceId/boards/'
    | '/workspace/$workspaceId/campaigns/'
    | '/workspace/$workspaceId/discovery/'
    | '/workspace/$workspaceId/insight/'
    | '/workspace/$workspaceId/saved-profiles/'
    | '/workspace/$workspaceId/settings/'
    | '/workspace/$workspaceId/campaigns/$campaignId/'
    | '/workspace/$workspaceId/saved-profiles/$listId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  InviteRoute: typeof InviteRoute
  ScoutDownloadRoute: typeof ScoutDownloadRoute
  ScrapingRoute: typeof ScrapingRoute
  WorkspaceWorkspaceIdRouteRoute: typeof WorkspaceWorkspaceIdRouteRouteWithChildren
  WorkspaceCreateRouteRoute: typeof WorkspaceCreateRouteRouteWithChildren
  CheckoutReturnRoute: typeof CheckoutReturnRoute
  LoginMicrosoftRoute: typeof LoginMicrosoftRoute
  LoginScoutRoute: typeof LoginScoutRoute
  WorkspaceInternalRoute: typeof WorkspaceInternalRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scout-download': {
      id: '/scout-download'
      path: '/scout-download'
      fullPath: '/scout-download'
      preLoaderRoute: typeof ScoutDownloadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scraping': {
      id: '/scraping'
      path: '/scraping'
      fullPath: '/scraping'
      preLoaderRoute: typeof ScrapingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/return': {
      id: '/checkout/return'
      path: '/checkout/return'
      fullPath: '/checkout/return'
      preLoaderRoute: typeof CheckoutReturnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/microsoft': {
      id: '/login/microsoft'
      path: '/login/microsoft'
      fullPath: '/login/microsoft'
      preLoaderRoute: typeof LoginMicrosoftRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/scout': {
      id: '/login/scout'
      path: '/login/scout'
      fullPath: '/login/scout'
      preLoaderRoute: typeof LoginScoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId': {
      id: '/workspace/$workspaceId'
      path: '/workspace/$workspaceId'
      fullPath: '/workspace/$workspaceId'
      preLoaderRoute: typeof WorkspaceWorkspaceIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/create': {
      id: '/workspace/create'
      path: '/workspace/create'
      fullPath: '/workspace/create'
      preLoaderRoute: typeof WorkspaceCreateRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/internal': {
      id: '/workspace/internal'
      path: '/workspace/internal'
      fullPath: '/workspace/internal'
      preLoaderRoute: typeof WorkspaceInternalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspace/$workspaceId/': {
      id: '/workspace/$workspaceId/'
      path: '/'
      fullPath: '/workspace/$workspaceId/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/$workspaceId/checkout': {
      id: '/workspace/$workspaceId/checkout'
      path: '/checkout'
      fullPath: '/workspace/$workspaceId/checkout'
      preLoaderRoute: typeof WorkspaceWorkspaceIdCheckoutRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/$workspaceId/create-new': {
      id: '/workspace/$workspaceId/create-new'
      path: '/create-new'
      fullPath: '/workspace/$workspaceId/create-new'
      preLoaderRoute: typeof WorkspaceWorkspaceIdCreateNewRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/$workspaceId/insight': {
      id: '/workspace/$workspaceId/insight'
      path: '/insight'
      fullPath: '/workspace/$workspaceId/insight'
      preLoaderRoute: typeof WorkspaceWorkspaceIdInsightRouteRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/$workspaceId/invalid-workspace': {
      id: '/workspace/$workspaceId/invalid-workspace'
      path: '/invalid-workspace'
      fullPath: '/workspace/$workspaceId/invalid-workspace'
      preLoaderRoute: typeof WorkspaceWorkspaceIdInvalidWorkspaceRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/$workspaceId/listening': {
      id: '/workspace/$workspaceId/listening'
      path: '/listening'
      fullPath: '/workspace/$workspaceId/listening'
      preLoaderRoute: typeof WorkspaceWorkspaceIdListeningRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/$workspaceId/plan-required': {
      id: '/workspace/$workspaceId/plan-required'
      path: '/plan-required'
      fullPath: '/workspace/$workspaceId/plan-required'
      preLoaderRoute: typeof WorkspaceWorkspaceIdPlanRequiredRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/$workspaceId/settings': {
      id: '/workspace/$workspaceId/settings'
      path: '/settings'
      fullPath: '/workspace/$workspaceId/settings'
      preLoaderRoute: typeof WorkspaceWorkspaceIdSettingsRouteRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/create/': {
      id: '/workspace/create/'
      path: '/'
      fullPath: '/workspace/create/'
      preLoaderRoute: typeof WorkspaceCreateIndexRouteImport
      parentRoute: typeof WorkspaceCreateRouteRoute
    }
    '/workspace/create/name': {
      id: '/workspace/create/name'
      path: '/name'
      fullPath: '/workspace/create/name'
      preLoaderRoute: typeof WorkspaceCreateNameRouteImport
      parentRoute: typeof WorkspaceCreateRouteRoute
    }
    '/workspace/$workspaceId/ask-syncly/': {
      id: '/workspace/$workspaceId/ask-syncly/'
      path: '/ask-syncly'
      fullPath: '/workspace/$workspaceId/ask-syncly/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdAskSynclyIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/$workspaceId/boards/': {
      id: '/workspace/$workspaceId/boards/'
      path: '/boards'
      fullPath: '/workspace/$workspaceId/boards/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdBoardsIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/$workspaceId/boards/$boardId': {
      id: '/workspace/$workspaceId/boards/$boardId'
      path: '/boards/$boardId'
      fullPath: '/workspace/$workspaceId/boards/$boardId'
      preLoaderRoute: typeof WorkspaceWorkspaceIdBoardsBoardIdRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/$workspaceId/campaigns/': {
      id: '/workspace/$workspaceId/campaigns/'
      path: '/campaigns'
      fullPath: '/workspace/$workspaceId/campaigns/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdCampaignsIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/$workspaceId/campaigns/create': {
      id: '/workspace/$workspaceId/campaigns/create'
      path: '/campaigns/create'
      fullPath: '/workspace/$workspaceId/campaigns/create'
      preLoaderRoute: typeof WorkspaceWorkspaceIdCampaignsCreateRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/$workspaceId/discovery/': {
      id: '/workspace/$workspaceId/discovery/'
      path: '/discovery'
      fullPath: '/workspace/$workspaceId/discovery/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdDiscoveryIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/$workspaceId/insight/': {
      id: '/workspace/$workspaceId/insight/'
      path: '/'
      fullPath: '/workspace/$workspaceId/insight/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdInsightIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdInsightRouteRoute
    }
    '/workspace/$workspaceId/insight/filtered-posts': {
      id: '/workspace/$workspaceId/insight/filtered-posts'
      path: '/filtered-posts'
      fullPath: '/workspace/$workspaceId/insight/filtered-posts'
      preLoaderRoute: typeof WorkspaceWorkspaceIdInsightFilteredPostsRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdInsightRouteRoute
    }
    '/workspace/$workspaceId/insight/filtered-profiles': {
      id: '/workspace/$workspaceId/insight/filtered-profiles'
      path: '/filtered-profiles'
      fullPath: '/workspace/$workspaceId/insight/filtered-profiles'
      preLoaderRoute: typeof WorkspaceWorkspaceIdInsightFilteredProfilesRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdInsightRouteRoute
    }
    '/workspace/$workspaceId/insight/overview': {
      id: '/workspace/$workspaceId/insight/overview'
      path: '/overview'
      fullPath: '/workspace/$workspaceId/insight/overview'
      preLoaderRoute: typeof WorkspaceWorkspaceIdInsightOverviewRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdInsightRouteRoute
    }
    '/workspace/$workspaceId/insight/people': {
      id: '/workspace/$workspaceId/insight/people'
      path: '/people'
      fullPath: '/workspace/$workspaceId/insight/people'
      preLoaderRoute: typeof WorkspaceWorkspaceIdInsightPeopleRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdInsightRouteRoute
    }
    '/workspace/$workspaceId/insight/performance': {
      id: '/workspace/$workspaceId/insight/performance'
      path: '/performance'
      fullPath: '/workspace/$workspaceId/insight/performance'
      preLoaderRoute: typeof WorkspaceWorkspaceIdInsightPerformanceRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdInsightRouteRoute
    }
    '/workspace/$workspaceId/insight/posts': {
      id: '/workspace/$workspaceId/insight/posts'
      path: '/posts'
      fullPath: '/workspace/$workspaceId/insight/posts'
      preLoaderRoute: typeof WorkspaceWorkspaceIdInsightPostsRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdInsightRouteRoute
    }
    '/workspace/$workspaceId/insight/referenced-posts': {
      id: '/workspace/$workspaceId/insight/referenced-posts'
      path: '/referenced-posts'
      fullPath: '/workspace/$workspaceId/insight/referenced-posts'
      preLoaderRoute: typeof WorkspaceWorkspaceIdInsightReferencedPostsRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdInsightRouteRoute
    }
    '/workspace/$workspaceId/post/$postId': {
      id: '/workspace/$workspaceId/post/$postId'
      path: '/post/$postId'
      fullPath: '/workspace/$workspaceId/post/$postId'
      preLoaderRoute: typeof WorkspaceWorkspaceIdPostPostIdRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/$workspaceId/saved-profiles/': {
      id: '/workspace/$workspaceId/saved-profiles/'
      path: '/saved-profiles'
      fullPath: '/workspace/$workspaceId/saved-profiles/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdSavedProfilesIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/$workspaceId/settings/': {
      id: '/workspace/$workspaceId/settings/'
      path: '/'
      fullPath: '/workspace/$workspaceId/settings/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdSettingsIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdSettingsRouteRoute
    }
    '/workspace/$workspaceId/settings/billing': {
      id: '/workspace/$workspaceId/settings/billing'
      path: '/billing'
      fullPath: '/workspace/$workspaceId/settings/billing'
      preLoaderRoute: typeof WorkspaceWorkspaceIdSettingsBillingRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdSettingsRouteRoute
    }
    '/workspace/$workspaceId/settings/general': {
      id: '/workspace/$workspaceId/settings/general'
      path: '/general'
      fullPath: '/workspace/$workspaceId/settings/general'
      preLoaderRoute: typeof WorkspaceWorkspaceIdSettingsGeneralRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdSettingsRouteRoute
    }
    '/workspace/$workspaceId/settings/member': {
      id: '/workspace/$workspaceId/settings/member'
      path: '/member'
      fullPath: '/workspace/$workspaceId/settings/member'
      preLoaderRoute: typeof WorkspaceWorkspaceIdSettingsMemberRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdSettingsRouteRoute
    }
    '/workspace/$workspaceId/settings/plan': {
      id: '/workspace/$workspaceId/settings/plan'
      path: '/plan'
      fullPath: '/workspace/$workspaceId/settings/plan'
      preLoaderRoute: typeof WorkspaceWorkspaceIdSettingsPlanRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdSettingsRouteRoute
    }
    '/workspace/$workspaceId/settings/usage': {
      id: '/workspace/$workspaceId/settings/usage'
      path: '/usage'
      fullPath: '/workspace/$workspaceId/settings/usage'
      preLoaderRoute: typeof WorkspaceWorkspaceIdSettingsUsageRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdSettingsRouteRoute
    }
    '/workspace/$workspaceId/campaigns/$campaignId/': {
      id: '/workspace/$workspaceId/campaigns/$campaignId/'
      path: '/campaigns/$campaignId'
      fullPath: '/workspace/$workspaceId/campaigns/$campaignId/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdCampaignsCampaignIdIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
    '/workspace/$workspaceId/saved-profiles/$listId/': {
      id: '/workspace/$workspaceId/saved-profiles/$listId/'
      path: '/saved-profiles/$listId'
      fullPath: '/workspace/$workspaceId/saved-profiles/$listId/'
      preLoaderRoute: typeof WorkspaceWorkspaceIdSavedProfilesListIdIndexRouteImport
      parentRoute: typeof WorkspaceWorkspaceIdRouteRoute
    }
  }
}

interface WorkspaceWorkspaceIdInsightRouteRouteChildren {
  WorkspaceWorkspaceIdInsightFilteredPostsRoute: typeof WorkspaceWorkspaceIdInsightFilteredPostsRoute
  WorkspaceWorkspaceIdInsightFilteredProfilesRoute: typeof WorkspaceWorkspaceIdInsightFilteredProfilesRoute
  WorkspaceWorkspaceIdInsightOverviewRoute: typeof WorkspaceWorkspaceIdInsightOverviewRoute
  WorkspaceWorkspaceIdInsightPeopleRoute: typeof WorkspaceWorkspaceIdInsightPeopleRoute
  WorkspaceWorkspaceIdInsightPerformanceRoute: typeof WorkspaceWorkspaceIdInsightPerformanceRoute
  WorkspaceWorkspaceIdInsightPostsRoute: typeof WorkspaceWorkspaceIdInsightPostsRoute
  WorkspaceWorkspaceIdInsightReferencedPostsRoute: typeof WorkspaceWorkspaceIdInsightReferencedPostsRoute
  WorkspaceWorkspaceIdInsightIndexRoute: typeof WorkspaceWorkspaceIdInsightIndexRoute
}

const WorkspaceWorkspaceIdInsightRouteRouteChildren: WorkspaceWorkspaceIdInsightRouteRouteChildren =
  {
    WorkspaceWorkspaceIdInsightFilteredPostsRoute:
      WorkspaceWorkspaceIdInsightFilteredPostsRoute,
    WorkspaceWorkspaceIdInsightFilteredProfilesRoute:
      WorkspaceWorkspaceIdInsightFilteredProfilesRoute,
    WorkspaceWorkspaceIdInsightOverviewRoute:
      WorkspaceWorkspaceIdInsightOverviewRoute,
    WorkspaceWorkspaceIdInsightPeopleRoute:
      WorkspaceWorkspaceIdInsightPeopleRoute,
    WorkspaceWorkspaceIdInsightPerformanceRoute:
      WorkspaceWorkspaceIdInsightPerformanceRoute,
    WorkspaceWorkspaceIdInsightPostsRoute:
      WorkspaceWorkspaceIdInsightPostsRoute,
    WorkspaceWorkspaceIdInsightReferencedPostsRoute:
      WorkspaceWorkspaceIdInsightReferencedPostsRoute,
    WorkspaceWorkspaceIdInsightIndexRoute:
      WorkspaceWorkspaceIdInsightIndexRoute,
  }

const WorkspaceWorkspaceIdInsightRouteRouteWithChildren =
  WorkspaceWorkspaceIdInsightRouteRoute._addFileChildren(
    WorkspaceWorkspaceIdInsightRouteRouteChildren,
  )

interface WorkspaceWorkspaceIdSettingsRouteRouteChildren {
  WorkspaceWorkspaceIdSettingsBillingRoute: typeof WorkspaceWorkspaceIdSettingsBillingRoute
  WorkspaceWorkspaceIdSettingsGeneralRoute: typeof WorkspaceWorkspaceIdSettingsGeneralRoute
  WorkspaceWorkspaceIdSettingsMemberRoute: typeof WorkspaceWorkspaceIdSettingsMemberRoute
  WorkspaceWorkspaceIdSettingsPlanRoute: typeof WorkspaceWorkspaceIdSettingsPlanRoute
  WorkspaceWorkspaceIdSettingsUsageRoute: typeof WorkspaceWorkspaceIdSettingsUsageRoute
  WorkspaceWorkspaceIdSettingsIndexRoute: typeof WorkspaceWorkspaceIdSettingsIndexRoute
}

const WorkspaceWorkspaceIdSettingsRouteRouteChildren: WorkspaceWorkspaceIdSettingsRouteRouteChildren =
  {
    WorkspaceWorkspaceIdSettingsBillingRoute:
      WorkspaceWorkspaceIdSettingsBillingRoute,
    WorkspaceWorkspaceIdSettingsGeneralRoute:
      WorkspaceWorkspaceIdSettingsGeneralRoute,
    WorkspaceWorkspaceIdSettingsMemberRoute:
      WorkspaceWorkspaceIdSettingsMemberRoute,
    WorkspaceWorkspaceIdSettingsPlanRoute:
      WorkspaceWorkspaceIdSettingsPlanRoute,
    WorkspaceWorkspaceIdSettingsUsageRoute:
      WorkspaceWorkspaceIdSettingsUsageRoute,
    WorkspaceWorkspaceIdSettingsIndexRoute:
      WorkspaceWorkspaceIdSettingsIndexRoute,
  }

const WorkspaceWorkspaceIdSettingsRouteRouteWithChildren =
  WorkspaceWorkspaceIdSettingsRouteRoute._addFileChildren(
    WorkspaceWorkspaceIdSettingsRouteRouteChildren,
  )

interface WorkspaceWorkspaceIdRouteRouteChildren {
  WorkspaceWorkspaceIdInsightRouteRoute: typeof WorkspaceWorkspaceIdInsightRouteRouteWithChildren
  WorkspaceWorkspaceIdSettingsRouteRoute: typeof WorkspaceWorkspaceIdSettingsRouteRouteWithChildren
  WorkspaceWorkspaceIdCheckoutRoute: typeof WorkspaceWorkspaceIdCheckoutRoute
  WorkspaceWorkspaceIdCreateNewRoute: typeof WorkspaceWorkspaceIdCreateNewRoute
  WorkspaceWorkspaceIdInvalidWorkspaceRoute: typeof WorkspaceWorkspaceIdInvalidWorkspaceRoute
  WorkspaceWorkspaceIdListeningRoute: typeof WorkspaceWorkspaceIdListeningRoute
  WorkspaceWorkspaceIdPlanRequiredRoute: typeof WorkspaceWorkspaceIdPlanRequiredRoute
  WorkspaceWorkspaceIdIndexRoute: typeof WorkspaceWorkspaceIdIndexRoute
  WorkspaceWorkspaceIdBoardsBoardIdRoute: typeof WorkspaceWorkspaceIdBoardsBoardIdRoute
  WorkspaceWorkspaceIdCampaignsCreateRoute: typeof WorkspaceWorkspaceIdCampaignsCreateRoute
  WorkspaceWorkspaceIdPostPostIdRoute: typeof WorkspaceWorkspaceIdPostPostIdRoute
  WorkspaceWorkspaceIdAskSynclyIndexRoute: typeof WorkspaceWorkspaceIdAskSynclyIndexRoute
  WorkspaceWorkspaceIdBoardsIndexRoute: typeof WorkspaceWorkspaceIdBoardsIndexRoute
  WorkspaceWorkspaceIdCampaignsIndexRoute: typeof WorkspaceWorkspaceIdCampaignsIndexRoute
  WorkspaceWorkspaceIdDiscoveryIndexRoute: typeof WorkspaceWorkspaceIdDiscoveryIndexRoute
  WorkspaceWorkspaceIdSavedProfilesIndexRoute: typeof WorkspaceWorkspaceIdSavedProfilesIndexRoute
  WorkspaceWorkspaceIdCampaignsCampaignIdIndexRoute: typeof WorkspaceWorkspaceIdCampaignsCampaignIdIndexRoute
  WorkspaceWorkspaceIdSavedProfilesListIdIndexRoute: typeof WorkspaceWorkspaceIdSavedProfilesListIdIndexRoute
}

const WorkspaceWorkspaceIdRouteRouteChildren: WorkspaceWorkspaceIdRouteRouteChildren =
  {
    WorkspaceWorkspaceIdInsightRouteRoute:
      WorkspaceWorkspaceIdInsightRouteRouteWithChildren,
    WorkspaceWorkspaceIdSettingsRouteRoute:
      WorkspaceWorkspaceIdSettingsRouteRouteWithChildren,
    WorkspaceWorkspaceIdCheckoutRoute: WorkspaceWorkspaceIdCheckoutRoute,
    WorkspaceWorkspaceIdCreateNewRoute: WorkspaceWorkspaceIdCreateNewRoute,
    WorkspaceWorkspaceIdInvalidWorkspaceRoute:
      WorkspaceWorkspaceIdInvalidWorkspaceRoute,
    WorkspaceWorkspaceIdListeningRoute: WorkspaceWorkspaceIdListeningRoute,
    WorkspaceWorkspaceIdPlanRequiredRoute:
      WorkspaceWorkspaceIdPlanRequiredRoute,
    WorkspaceWorkspaceIdIndexRoute: WorkspaceWorkspaceIdIndexRoute,
    WorkspaceWorkspaceIdBoardsBoardIdRoute:
      WorkspaceWorkspaceIdBoardsBoardIdRoute,
    WorkspaceWorkspaceIdCampaignsCreateRoute:
      WorkspaceWorkspaceIdCampaignsCreateRoute,
    WorkspaceWorkspaceIdPostPostIdRoute: WorkspaceWorkspaceIdPostPostIdRoute,
    WorkspaceWorkspaceIdAskSynclyIndexRoute:
      WorkspaceWorkspaceIdAskSynclyIndexRoute,
    WorkspaceWorkspaceIdBoardsIndexRoute: WorkspaceWorkspaceIdBoardsIndexRoute,
    WorkspaceWorkspaceIdCampaignsIndexRoute:
      WorkspaceWorkspaceIdCampaignsIndexRoute,
    WorkspaceWorkspaceIdDiscoveryIndexRoute:
      WorkspaceWorkspaceIdDiscoveryIndexRoute,
    WorkspaceWorkspaceIdSavedProfilesIndexRoute:
      WorkspaceWorkspaceIdSavedProfilesIndexRoute,
    WorkspaceWorkspaceIdCampaignsCampaignIdIndexRoute:
      WorkspaceWorkspaceIdCampaignsCampaignIdIndexRoute,
    WorkspaceWorkspaceIdSavedProfilesListIdIndexRoute:
      WorkspaceWorkspaceIdSavedProfilesListIdIndexRoute,
  }

const WorkspaceWorkspaceIdRouteRouteWithChildren =
  WorkspaceWorkspaceIdRouteRoute._addFileChildren(
    WorkspaceWorkspaceIdRouteRouteChildren,
  )

interface WorkspaceCreateRouteRouteChildren {
  WorkspaceCreateNameRoute: typeof WorkspaceCreateNameRoute
  WorkspaceCreateIndexRoute: typeof WorkspaceCreateIndexRoute
}

const WorkspaceCreateRouteRouteChildren: WorkspaceCreateRouteRouteChildren = {
  WorkspaceCreateNameRoute: WorkspaceCreateNameRoute,
  WorkspaceCreateIndexRoute: WorkspaceCreateIndexRoute,
}

const WorkspaceCreateRouteRouteWithChildren =
  WorkspaceCreateRouteRoute._addFileChildren(WorkspaceCreateRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  InviteRoute: InviteRoute,
  ScoutDownloadRoute: ScoutDownloadRoute,
  ScrapingRoute: ScrapingRoute,
  WorkspaceWorkspaceIdRouteRoute: WorkspaceWorkspaceIdRouteRouteWithChildren,
  WorkspaceCreateRouteRoute: WorkspaceCreateRouteRouteWithChildren,
  CheckoutReturnRoute: CheckoutReturnRoute,
  LoginMicrosoftRoute: LoginMicrosoftRoute,
  LoginScoutRoute: LoginScoutRoute,
  WorkspaceInternalRoute: WorkspaceInternalRoute,
  LoginIndexRoute: LoginIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
